module.exports = __webpack_public_path__ + "notification_left.svg?e9afd8032b0244d4fc1c6412b9526e92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/notification_left.svg
// module id = 190
// module chunks = 0